import { render, staticRenderFns } from "./CreateNewHero.vue?vue&type=template&id=4201667a&"
import script from "./CreateNewHero.vue?vue&type=script&lang=js&"
export * from "./CreateNewHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports